<script setup lang="ts">
import { MessageStatus } from '@/Enums/MessageStatus'

const { status, size, messageKey } = defineProps<{
  status: number
  size?: string
  messageKey?: string
}>()

function resendFailedMessage() {
  if (!messageKey) return

  const activeChatStore = useActiveChatStore()
  activeChatStore.resendFailedMessage({ messageKey: messageKey })
}
</script>
<template>
  <template v-if="status === MessageStatus.ERROR">
    <span
      class="material-symbols-outlined tw-text-red-600 tw-cursor-not-allowed"
      :style="{
        fontSize: size || '13px',
      }"
    >
      error
    </span>
    <span
      v-if="messageKey"
      class="tw-text-sm tw-daisy-link tw-daisy-link-info"
      @click="resendFailedMessage"
    >
      Reenviar
    </span>
  </template>
  <span
    v-else-if="status === MessageStatus.PENDING"
    class="material-symbols-outlined"
    :style="{
      fontSize: size || '13px',
    }"
  >
    schedule
  </span>
  <span
    v-else-if="status === MessageStatus.SENT"
    class="material-symbols-outlined"
    :style="{
      fontSize: size || '13px',
    }"
  >
    done
  </span>
  <span
    v-else-if="status === MessageStatus.ON_DEVICE"
    class="material-symbols-outlined"
    :style="{
      fontSize: size || '13px',
    }"
  >
    done_all
  </span>
  <span
    v-else-if="status === MessageStatus.READ || status === MessageStatus.PLAYED"
    class="material-symbols-outlined tw-text-[#53bdeb]"
    :style="{
      fontSize: size || '13px',
    }"
  >
    done_all
  </span>
  <span
    v-else-if="status === MessageStatus.RECEIVED"
    class="material-symbols-outlined tw-text-[#53bdeb]"
    :style="{
      fontSize: size || '13px',
    }"
  >
    sync_alt
  </span>
  <div
    v-else-if="status === MessageStatus.REENGAGEMENT"
    class="tw-daisy-tooltip tw-daisy-tooltip-left"
    data-tip="Mensagem não entregue. A Janela de conversação com o cliente foi encerrada."
  >
    <span
      class="material-symbols-outlined tw-text-red-600 tw-cursor-not-allowed"
      :style="{
        fontSize: size || '13px',
      }"
    >
      chat_error
    </span>
  </div>
</template>
